var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnnotationsCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 57,
    viewBox: "0 0 60 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_2188_5580)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 2.52246,
    width: 44,
    height: 44,
    rx: 22,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3876 24.5212L36.4188 16.14C36.5367 16.0007 36.4376 15.7891 36.2554 15.7891H34.1179C33.992 15.7891 33.8715 15.8453 33.7885 15.9417L27.9894 22.8551L22.1903 15.9417C22.1099 15.8453 21.9894 15.7891 21.8608 15.7891H19.7233C19.5411 15.7891 19.442 16.0007 19.5599 16.14L26.5911 24.5212L19.5599 32.9025C19.5335 32.9335 19.5166 32.9715 19.5111 33.0119C19.5056 33.0522 19.5119 33.0934 19.5291 33.1303C19.5463 33.1672 19.5737 33.1985 19.6081 33.2203C19.6426 33.2421 19.6825 33.2536 19.7233 33.2533H21.8608C21.9867 33.2533 22.1072 33.1971 22.1903 33.1007L27.9894 26.1873L33.7885 33.1007C33.8688 33.1971 33.9894 33.2533 34.1179 33.2533H36.2554C36.4376 33.2533 36.5367 33.0417 36.4188 32.9025L29.3876 24.5212Z",
    fill: "#12C1E8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_2188_5580",
    x: 0,
    y: 0.522461,
    width: 60,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2188_5580"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2188_5580",
    result: "effect2_dropShadow_2188_5580"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2188_5580",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnotationsCloseIcon);
export default __webpack_public_path__ + "static/media/annotationsCloseIcon.2347f49c07ec70c6c7e0e487f0e5892a.svg";
export { ForwardRef as ReactComponent };